export default "__VITE_PUBLIC_ASSET__61481eb5__"